import Trans from 'next-translate/Trans';
import { useState } from 'react';

import { Box, Icon, Link, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextMediaQuery } from '@core/context';
import { useLanguage } from '@core/hook';
import {
  EActionAttribute,
  EColor,
  EFontWeight,
  EIcon,
  ESize,
  ETypographyVariant,
} from '@core/type';
import { ProductBlockEntity } from '@core/type/api';
import { formatDatePeriod } from '@core/util';
import { ModalWhatIsPreorder } from '@core/widget';

export const PreorderText = ({
  preorder: { estimatedArrival },
}: Pick<ProductBlockEntity, 'preorder'>) => {
  const { isPhone } = useContextMediaQuery();
  const { language } = useLanguage();

  const { arrivalFrom, arrivalTo } = estimatedArrival;

  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      <Box display={isPhone ? 'flex' : undefined} justifyContent={isPhone ? 'center' : undefined}>
        <Typography
          variant={ETypographyVariant.BODY2}
          textAlign={isPhone ? 'center' : undefined}
          display="inline-block"
        >
          <Trans
            i18nKey={`${Translate.common.PRODUCT}:productPresale`}
            components={{
              boldText: (
                <Link
                  as={EActionAttribute.SPAN}
                  variant={ETypographyVariant.BODY2}
                  fontWeight={EFontWeight.BOLD}
                  isUnderlinedHover
                  onClick={() => {
                    setIsOpen((isOpen) => !isOpen);
                  }}
                />
              ),
            }}
          />
        </Typography>
        <Box
          cursor="pointer"
          display="inline-block"
          onClick={() => {
            setIsOpen((isOpen) => !isOpen);
          }}
        >
          <Icon
            marginLeft="4px"
            display="inline-block"
            position="relative"
            bottom="4px"
            type={EIcon.INFO}
            color={EColor.INFO}
            size={ESize.XXS}
          />
        </Box>
      </Box>

      <Typography
        variant={ETypographyVariant.BODY2}
        textAlign={isPhone ? 'center' : undefined}
        marginBottom={isPhone ? '8px' : '16px'}
      >
        <Trans
          i18nKey={`${Translate.common.PRODUCT}:estimatedArrival`}
          values={{
            datePeriod: formatDatePeriod(arrivalFrom, arrivalTo, language),
          }}
          components={{
            boldText: (
              <Typography
                as={EActionAttribute.SPAN}
                variant={ETypographyVariant.BODY2}
                fontWeight={EFontWeight.BOLD}
              />
            ),
          }}
        />
      </Typography>
      <ModalWhatIsPreorder onCloseModal={() => setIsOpen(false)} isOpen={isOpen} />
    </>
  );
};
